import React from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import NavLinks from '../shared/NavLinks';

import logo from '../assets/images/logo.svg';


const NavBar = styled.nav`
  @media (min-width: 992px) {
    position: fixed;
  }
`;

const Brand = styled.a`
  text-decoration: none;
  color: inherit;
`;

const Logo = styled.img`
  width: 1.57vw;
  border-radius: 4px;
  float: left;
  margin-top: 3px;

  @media (max-width: 64em) {
    width: 5.2vw;
  }
`;

const Title = styled.h1`
  font-family: 'Bitter', serif;
  font-size: 1.2rem;
  margin-left: 13px;
  margin-top: 2px;
  margin-bottom: 0;
  float: left;
  font-size: 1.43vw;

  @media (max-width: 64em) {
    font-size: 4.73vw;
  }
`;

const MainNavLinkList = styled.ul`
  float: left;
  list-style: none;
  font-size: 0.9rem;
  margin-top: 0.5vw;
  margin-bottom: 0;
`;

const MainNavLinkListItem = styled.li`
  float: left;

  &::after{
    content: '/';
    font-size: 1vw;
    margin-left: 1.1vw;
    margin-right: 1.1vw;
  }

  &.last{
    &::after{
      content: '';
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

const Hamburger = styled.div`
  cursor: pointer;
  float: right;
  margin-top: 3px;

  &.is-active .line:nth-child(2){
    opacity: 0;
  }

  &.is-active .line:nth-child(1){
    -webkit-transform: translateY(6.5px) rotate(45deg);
    -ms-transform: translateY(6.5px) rotate(45deg);
    -o-transform: translateY(6.5px) rotate(45deg);
    transform: translateY(6.5px) rotate(45deg);
  }

  &.is-active .line:nth-child(3){
    -webkit-transform: translateY(-6.5px) rotate(-45deg);
    -ms-transform: translateY(-6.5px) rotate(-45deg);
    -o-transform: translateY(-6.5px) rotate(-45deg);
    transform: translateY(-6.5px) rotate(-45deg);
  }

`;

const HamburgerLine = styled.span`
  width: 24px;
  height: 3px;
  background-color: #262636;
  display: block;
  margin: 3px auto;
  border-radius: 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
`;

const MainNavLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  font-size: 1vw;
`;

const MainNav = ({ toggleMobileNav }) => (
  <div>
    <NavBar>
      <Brand href="/">
        <Logo src={logo} alt="LeafyCode Logo" />
        <Title>LeafyCode</Title>
      </Brand>

      <MediaQuery minWidth={992}>
        <NavLinks
          NavLinkList={MainNavLinkList}
          NavLinkListItem={MainNavLinkListItem}
          NavLink={MainNavLink}
        />
      </MediaQuery>
    </NavBar>

    <MediaQuery maxWidth={991} onClick={toggleMobileNav}>
      <Hamburger id="hamburger">
        <HamburgerLine className="line" />
        <HamburgerLine className="line" />
        <HamburgerLine className="line" />
      </Hamburger>
    </MediaQuery>
  </div>
);

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav.js